import * as Dialog from '@radix-ui/react-dialog';
import { RotateCw, X } from 'lucide-react';

import { cn } from '@control-center/ui';

import { PillButton } from '../../clients/PillButton';

interface RetryConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemSummary: string | null;
  onConfirm: () => void;
  isPending: boolean;
}

export function RetryConfirmDialog({
  open,
  onOpenChange,
  itemSummary,
  onConfirm,
  isPending,
}: RetryConfirmDialogProps): JSX.Element {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn(
            'fixed inset-0 z-40 bg-black/60 backdrop-blur-[2px]',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          )}
        />
        <Dialog.Content
          className={cn(
            'fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2',
            'w-[min(440px,calc(100vw-32px))] max-h-[90dvh] overflow-y-auto',
            'rounded-[14px] border border-line bg-panel p-6 shadow-lg focus:outline-none',
          )}
        >
          <div className="mb-4 flex items-start justify-between gap-4">
            <Dialog.Title className="flex items-center gap-2 text-[16px] font-semibold tracking-[-0.005em] text-ink">
              <RotateCw size={15} strokeWidth={2} className="text-brand" />
              Reprocessar notificação?
            </Dialog.Title>
            <Dialog.Close asChild>
              <button
                type="button"
                aria-label="Fechar"
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-[6px] text-muted transition-colors hover:bg-panel-2 hover:text-ink"
              >
                <X size={14} strokeWidth={2} />
              </button>
            </Dialog.Close>
          </div>

          <Dialog.Description className="text-[13px] leading-relaxed text-muted">
            A notificação será re-enfileirada com 4 tentativas (1m/5m/15m de backoff) e sairá da
            DLQ. {itemSummary && <span className="text-ink">{itemSummary}</span>}
          </Dialog.Description>

          <div className="mt-5 flex items-center justify-end gap-2">
            <PillButton type="button" onClick={() => onOpenChange(false)} disabled={isPending}>
              Cancelar
            </PillButton>
            <PillButton type="button" solid onClick={onConfirm} disabled={isPending}>
              {isPending ? 'Reenfileirando…' : 'Confirmar reprocessar'}
            </PillButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
